import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LOCATION_FEATURE_KEY, LocationState } from './location.reducer';

// Lookup the 'Location' feature state managed by NgRx
export const getLocationState =
  createFeatureSelector<LocationState>(LOCATION_FEATURE_KEY);

export const getLocationLoaded = createSelector(
  getLocationState,
  (state: LocationState) => state.loaded,
);

export const getLocationError = createSelector(
  getLocationState,
  (state: LocationState) => state?.error,
);
export const getLocation = createSelector(
  getLocationState,
  (state: LocationState) => state.location,
);
export const getLocationBlockedToCash = createSelector(
  getLocationState,
  (state: LocationState) => state.blockedToCash,
);
export const getVerifyCashPlayStatus = createSelector(
  getLocationState,
  (state: LocationState) => state.verifyCashPlayStatus,
);

export const getLocationLoading = createSelector(
  getLocationState,
  (state: LocationState) => state.loading,
);
